import React from 'react';
import PropTypes from 'prop-types';
import { includes, isEmpty, map } from 'lodash/fp';
import { FastField } from 'formik';

import MultipleSelectionField from '../MultipleSelectionField';
import SingleSelectionField from '../SingleSelectionField';
import { DescriptiveField } from '..';

const QuestionRenderer = ({ large, questions, viewportWidth }) => questions && (
  <ol>
    {map((question) => (
      <li key={question.number}>
        {{
          SINGLE_SELECTION: question.type === 'SINGLE_SELECTION' && (
            <FastField
              name={`answers[${question.number - 1}]`}
              large={large}
              question={question}
              component={SingleSelectionField}
              validate={(value) => (question.required ? (!value || value === 'other:') : value === 'other:')}
              viewportWidth={viewportWidth}
            />
          ),
          MULTIPLE_SELECTION: question.type === 'MULTIPLE_SELECTION' && (
            <FastField
              name={`answers[${question.number - 1}]`}
              large={large}
              question={question}
              component={MultipleSelectionField}
              validate={(value) => (question.required ? (isEmpty(value) || includes('other:', value)) : includes('other:', value))}
              viewportWidth={viewportWidth}
            />
          ),
          DESCRIPTIVE: question.type === 'DESCRIPTIVE' && (
            <FastField
              name={`answers[${question.number - 1}]`}
              large={large}
              question={question}
              component={DescriptiveField}
              validate={(value) => question.required && !value}
            />
          ),
        }[question.type]}
      </li>
    ), questions)}
  </ol>
);

QuestionRenderer.propTypes = {
  large: PropTypes.bool,
  questions: PropTypes.arrayOf(PropTypes.shape({
    number: PropTypes.number.isRequired,
  })),
  viewportWidth: PropTypes.number,
};

QuestionRenderer.defaultProps = {
  large: false,
  questions: null,
  viewportWidth: null,
};

export default QuestionRenderer;
